import Router from 'vue-router'
import Vue from 'vue';

Vue.use(Router);

const router =new Router({
    mode: 'hash',
    base: '',
    routes: [
        {
            path: '/',
            component: () => import('./components/List'),
        },
        {
            path: '/menu/:taxon',
            component: () => import('./components/List'),
        },
        {
            path: '/checkout',
            component: () => import('./components/Checkout'),
        },
        {
            path: '/finalize',
            component: () => import('./components/Finalize'),
        }
    ]
});

/*
router.beforeEach((to, from, next) => {
    if ( test )) {

    } else {
        next();
    }
});
*/

export default router;
